// -----------------------------------------------------------------------------
//   Number Utilities
// -----------------------------------------------------------------------------

/**
 * Rounds a number to a specified number of decimal places.
 * Uses Number.EPSILON to handle floating point precision issues.
 * 
 * @param value - The number to round
 * @param decimals - Number of decimal places (default: 2)
 * @returns The rounded number
 */
export function roundTo(value: number, decimals: number = 2): number {
    const factor: number = Math.pow(10, decimals);
    return Math.round((value + Number.EPSILON) * factor) / factor;
}

/**
 * Rounds a number to 2 decimal places.
 * Convenience function for common 2-decimal rounding.
 */
export function round2(x: number): number {
    return roundTo(x, 2);
}
